module.exports = __webpack_public_path__ + "media/videoEnhancer.6ef19d53.mp4";